import { LitElement, utils, t } from '@hh/global.js'
const { reRenderShopifySections } = utils

class HHCartValidator extends LitElement {
  constructor() {
    super()
    this.isProcessing = false
    this.init()
  }

  connectedCallback() {
    super.connectedCallback()
    this.processNotAvailableProducts()
  }

  init() {
    window.addEventListener('cart:updated', () => {
      this.processNotAvailableProducts()
    })

    document.addEventListener('DOMContentLoaded', () => {
      this.processNotAvailableProducts()
    })
  }

  async processNotAvailableProducts() {
    const nonAvailableProducts = document.getElementById('nonAvailableProducts')
    if (this.isProcessing || !nonAvailableProducts) {
      return
    }

    this.isProcessing = true
    const productsToRemove = JSON.parse(nonAvailableProducts.textContent).products.filter(product => product.not_available_for_purchase);

    console.log(productsToRemove, "productsToRemove in processNotAvailableProducts");

    if (productsToRemove.length === 0) {
      this.isProcessing = false
      return
    }

    try {
      this.blockCart()

      for (const product of productsToRemove) {
        await this.removeProduct(product)
      }

      this.showRemovalNotification(productsToRemove)
      await reRenderShopifySections()

    } catch (error) {
      console.error('Error removing not-available-for-purchase products:', error)
    } finally {
      this.isProcessing = false
      this.unblockCart()
    }
  }

  unblockCart() {
    const cart = document.querySelector('#inline-cart')
    if (cart) {
      cart.classList.remove('loading')
    }
  }
  blockCart() {
    const cart = document.querySelector('#inline-cart')
    if (cart) {
      cart.classList.add('loading')
    }
  }
  async removeProduct(product) {
    try {
      const response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [product.variant_id]: 0
          },
          sections: 'mini-cart,header,inline-cart'
        })
      })

      if (!response.ok) {
        throw new Error(`Failed to remove product: ${response.statusText}`)
      }

      const cartData = await response.json()
      console.log(cartData, "cartData in removeProduct");
      
      await reRenderShopifySections(cartData)

      return cartData
    } catch (error) {
      console.error(`Error removing product ${product.title}:`, error)
      throw error
    }
  }

  showRemovalNotification(removedProducts) {
    if (removedProducts.length === 1) {
      const product = removedProducts[0]
      const message = t('cart.general.removed_not_available', `The product ${product.title} is no longer available and has been removed from your cart.`, { product_title: product.title })
      
      window.dispatchEvent(
        new CustomEvent('cart-message:removed-not-available', {
          bubbles: true,
          composed: true,
          detail: {
            title: product.title,
            message: message
          },
        })
      )
    } else {
      const titles = removedProducts.map(p => p.title).join(', ')
      const message = `The following products are no longer available and have been removed from your cart: ${titles}`
      window.dispatchEvent(
        new CustomEvent('cart-message:removed-not-available', {
          bubbles: true,
          composed: true,
          detail: {
            title: 'Multiple products',
            message: message
          },
        })
      )
    }

    this.dispatchEvent(
      new CustomEvent('productError', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'error-notification',
          message: removedProducts.length === 1 
            ? t('cart.general.removed_not_available', 'The product {{ product_title }} is no longer available and has been removed from your cart.', { product_title: removedProducts[0].title })
            : 'Some products are no longer available and have been removed from your cart.',
          auto_close: 4000,
        },
      })
    )
  }

  render() {
    return null
  }
}

if (!customElements.get('hh-cart-validator')) {
  customElements.define('hh-cart-validator', HHCartValidator)
}

export { HHCartValidator } 